/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.geofences.internal

import features.geofences.models.GeofencesModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class GeofencesRequest : NetworkRequest() {

    suspend fun getBusinessGeofences(
        overrideHeaders: Map<String, String>? = null,
        pageNumber: Int,
        perPage: Int
    ): IOResult<GeofencesModel> {
        return safeNetworkCall {
            get(
                endpoint = GeofencesEndpoint.replaceInPath(
                    PathParameter("pageNumber", pageNumber),
                    PathParameter("perPage", perPage),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
